// eslint-disable-next-line import/no-duplicates
import { format } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { es } from 'date-fns/locale';
// eslint-disable-next-line import/no-duplicates
import differenceInHours from 'date-fns/differenceInHours';
// eslint-disable-next-line import/no-duplicates
import differenceInMinutes from 'date-fns/differenceInMinutes';

const parseDate = (date: string): string => {
  let formattedDate: string = format(new Date(date), 'MMMM dd, yyyy', {
    locale: es,
  });

  const hoursDiff = differenceInHours(new Date(date), Date.now()) * -1;
  const minutesDiff = differenceInMinutes(new Date(date), Date.now()) * -1;

  if (minutesDiff < 1) {
    formattedDate = `hace menos de un minuto`;
  }

  if (minutesDiff === 1) {
    formattedDate = `hace un minuto`;
  }

  if (hoursDiff === 0 && minutesDiff > 1) {
    formattedDate = `hace ${minutesDiff} minutos`;
  }
  if (hoursDiff === 1) {
    formattedDate = `hace ${hoursDiff} hora`;
  }

  // if (hoursDiff > 1 && hoursDiff < 24) {
  //   formattedDate = `hace ${hoursDiff} horas`;
  // }


  return formattedDate;
};

export default parseDate;
